/** Convert an ISO date string to .NET DateTime ticks for latest-request API. */
export function toDotNetTicks(isoDate: string | undefined | null): string {
  if (!isoDate) return '0';

  const jsDate = new Date(isoDate);
  if (Number.isNaN(jsDate.getTime())) return '0';

  const DOTNET_EPOCH_TICKS = BigInt('621355968000000000');
  const ticks = BigInt(jsDate.getTime()) * BigInt(10000) + DOTNET_EPOCH_TICKS;
  return ticks.toString();
}
